import { createFileRoute } from "@tanstack/react-router";
import { WhyItCosts } from "./varfor-kostar-det";

export const Route = createFileRoute("/en/why-it-costs")({
  head: () => ({
    meta: [
      { title: "Why it costs something | Sellavo" },
      { name: "description", content: "What you pay for on Sellavo and what the money goes to." },
      { property: "og:title", content: "Why it costs something | Sellavo" },
      { property: "og:description", content: "What you pay for on Sellavo and what the money goes to." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/why-it-costs" }],
  }),
  component: WhyItCosts,
});
